var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"fill-height d-flex align-center justify-center",style:(_vm.elementStyle),attrs:{"color":!_vm.element.config.outlined ? _vm.GET_AVALON_COLOR(_vm.element.config.background_color) : 'transparent'}})}
var staticRenderFns = []

export { render, staticRenderFns }